module.exports = __webpack_public_path__ + "ec95ec28f8e97600f56ee8ae2c166590.svg";